import React from 'react';

import { flagStyles } from '../settings';

const SvgSA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4584px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSA;
